import { useEffect, useState } from "react";
import api from "../../api/axios";

import AppLayout from "../../layouts/AppLayout";

import TabButton from "../../components/TabButton";
import SettingCard from "../../components/SettingCard";
import SectionRow from "../../components/SectionRow";
import Switch from "../../components/Switch";
import PrimaryButton from "../../components/PrimaryButton";
import NumberField from "../../components/NumberField";
import { useNavigate } from "react-router-dom";
import DangerButton from "../../components/DangerButton";

function Setting() {

    const navigate = useNavigate();

    const [tab, setTab] = useState("basic");

    const [setting, setSetting] = useState({

        autoEnabled: false,

        totalStopLoss: -30,

        performance_score: 85,

        aiScore: 85,

        stopLoss: -3,

        takeProfit: 7,
    });

    useEffect(() => {

        api.get("/auto/setting")
            .then(res => {

                if (res.data) {

                    setSetting(res.data);

                }

            });

    }, []);

    const change = (name, value) => {

        setSetting(prev => ({

            ...prev,

            [name]: value

        }));

    };

    // 호가 시뮬 테스트용
    const simul = () => {
        api.get("/test/simul").then(res => {
            
        });
    }

    const save = () => {

        // 1. 로컬스토리지에서 userNo 값을 가져옵니다.
        const loggedInUserNo = localStorage.getItem("userNo");
        
        // 2. userNo가 없거나, 문자로 변환된 값이 "2"가 아닌 경우 체크
        if (!loggedInUserNo || loggedInUserNo !== "2") {
            
            alert("관리자만 수정 가능합니다.");
            
            // 더 이상 아래 로직이 실행되지 않도록 차단 (함수 내부라면 return 처리)
            return; 
        }

        api.post("/auto/setting", setting)

            .then(() => {

                alert("설정이 저장되었습니다.");

            });

    };

    const logout = () => {
        localStorage.clear();
        navigate("/login");
    };

    return (

        <AppLayout

            title="설정"

            subTitle="자동매매 설정"
        >

            {/* 탭 */}

            <div
                style={{
                    display: "flex",
                    background: "#fff",
                    borderRadius: "12px",
                    overflow: "hidden",
                    marginBottom: "15px"
                }}
            >

                <TabButton
                    text="기본"
                    active={tab === "basic"}
                    onClick={() => setTab("basic")}
                />

                <TabButton
                    text="전략"
                    active={tab === "strategy"}
                    onClick={() => setTab("strategy")}
                />

                <TabButton
                    text="AI"
                    active={tab === "ai"}
                    onClick={() => setTab("ai")}
                />

                <TabButton
                    text="위험"
                    active={tab === "risk"}
                    onClick={() => setTab("risk")}
                />

            </div>

            {/* 기본 */}

            {tab === "basic" && (

                <>

                    <SettingCard title="자동매매">

                        <SectionRow

                            title="자동매매 사용"

                            right={

                                <Switch

                                    checked={setting.autoEnabled}

                                    onChange={(v) => change("autoEnabled", v)}

                                />

                            }

                        />

                    </SettingCard>

                    {/* <SettingCard title="투자금">

                        <SectionRow

                            title="예수금 전체 사용"

                            right={

                                <Switch

                                    checked={setting.useAllBalance}

                                    onChange={(v) => change("useAllBalance", v)}

                                />

                            }

                        />

                        {

                            !setting.useAllBalance && (

                                <NumberField

                                    value={setting.maxInvestAmount}

                                    suffix="원"

                                    onChange={(v) => change("maxInvestAmount", Number(v))}

                                />

                            )

                        }

                    </SettingCard> */}

                </>

            )}

            {/* 전략 */}

            {tab === "strategy" && (

                <SettingCard title="매매 전략">

                    {/* <SectionRow
                        title="이동평균(MA)"
                        right={<Switch checked={setting.strategyMa} onChange={(v)=>change("strategyMa",v)} />}
                    />

                    <SectionRow
                        title="RSI"
                        right={<Switch checked={setting.strategyRsi} onChange={(v)=>change("strategyRsi",v)} />}
                    />

                    <SectionRow
                        title="MACD"
                        right={<Switch checked={setting.strategyMacd} onChange={(v)=>change("strategyMacd",v)} />}
                    />
*/}
<SectionRow

                        title="지표 최소 추천점수"

                        right={

                            <NumberField

                                value={setting.performanceScore || 0}

                                suffix="점"

                                onChange={(v)=>change("performanceScore", Number(v))}

                            />

                        }

                    />
                    {/* <SectionRow

                        title="1주당 최대 구매 단가 설정"

                        right={

                            <NumberField

                                value={setting.maxPurUnitPrice}

                                suffix="원"

                                onChange={(v)=>change("maxPurUnitPrice", Number(v))}

                            />

                        }

                    />  */}
                </SettingCard>

            )}

            {/* AI */}

            {tab === "ai" && (

                <SettingCard title="AI 설정">

                    <SectionRow

                        title="최소 추천점수"

                        right={

                            <NumberField

                                value={setting.aiScore || 0}

                                suffix="점"

                                onChange={(v)=>change("aiScore", Number(v))}

                            />

                        }

                    />

                </SettingCard>

            )}

            {/* 위험관리 */}

            {tab === "risk" && (

                <SettingCard title="위험관리">

                    <SectionRow

                        title="손절"

                        right={

                            <NumberField

                                value={setting.stopLoss || 0}

                                suffix="%"

                                onChange={(v)=>change("stopLoss", Number(v))}

                            />

                        }

                    />

                    <SectionRow

                        title="익절"

                        right={

                            <NumberField

                                value={setting.takeProfit || 0}

                                suffix="%"

                                onChange={(v)=>change("takeProfit", Number(v))}

                            />

                        }

                    />

                    <SectionRow

                        title="총 계좌 손절"

                        right={

                            <NumberField

                                value={setting.totalStopLoss || 0}

                                suffix="%"

                                onChange={(v)=>change("totalStopLoss", Number(v))}

                            />

                        }

                    />

                </SettingCard>

            )}

            <PrimaryButton text="설정 저장" onClick={save} />
            <DangerButton text="로그아웃" onClick={logout} />
            {process.env.REACT_APP_SERVER_TYPE === "local" ? <PrimaryButton text="호가 시뮬레이터 용 " onClick={simul} /> : ""}
        </AppLayout>

    );

}

export default Setting;
